import {
    setLocalStorageWithExpiry, getLocalStorageWithExpiry,
} from '@emyw/core-lib';
import { validatePromotionCode } from '@emyw/pay-lib/utils';
// import { DEFAULT_PROMO_CODE } from '@emyw/subscribe-lib/utils';

export const getUrlParams = () => {
    let params = new URLSearchParams(window.location.search);
    const redirectTo = params.get('redirectTo');
    if (params.has('redirectTo')) params = new URLSearchParams(unescape(window.location.search));
    return { params, redirectTo };
};

export const getCurrentPromoCode = async () => {
    const { params: urlParams } = getUrlParams();
    // Check if there is a promo code in the query string and store it for auto-application on checkout
    const base64Code = urlParams.get('promocode');
    // log.trace(Buffer.from(unescape(base64Code), 'base64').toString('ascii'));
    // We will always default to 7 DAYS FREE if no explicit promo code specified
    let promoCode = getLocalStorageWithExpiry('enjoy-promo-code');
    if (base64Code) {
        promoCode = Buffer.from(unescape(base64Code), 'base64').toString('ascii');
    } else { // if (!promoCode) {
        // promoCode = DEFAULT_PROMO_CODE;
        promoCode = null;
    }
    if (!promoCode) return null; // Won't ever happen if defaulting to DEFAULT_PROMO_CODE
    // Check if this promo code is valid
    // Since code is not being activated, a fake userId can be used at this time
    const res = await validatePromotionCode(promoCode, false, { id: -1 });
    if (res.ok) {
        setLocalStorageWithExpiry('enjoy-promo-code', promoCode, 604800000);
    } else {
        localStorage.removeItem('enjoy-promo-code');
    }
    // if (!res.ok) promoCode = DEFAULT_PROMO_CODE;
    // setLocalStorageWithExpiry('enjoy-promo-code', promoCode, 604800000);
    return promoCode;
};
